import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedComics from './components/FeaturedComics';
import LatestUpdates from './components/LatestUpdates';
import PopularSection from './components/PopularSection';

const structuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '香香漫画',
  url: 'https://xiangxiangmanhua.com',
  description: '海量韩漫免费阅读平台，韩漫全集下拉式畅读，最新韩漫追更，好看的韩漫免费漫画大全在线阅读',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://xiangxiangmanhua.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    document.title = '香香漫画 - 韩漫免费阅读 韩漫全集 下拉式 韩漫追更 | 最新韩漫 好看的韩漫免费漫画大全';
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryNav />
          <FeaturedComics />
          <LatestUpdates />
          <PopularSection />
        </main>
        <Footer />
      </div>
    </>
  );
}